export default {
  verificationCode: 'Verification code',
};
